import React from 'react';
import {Navigate, Route, Routes} from "react-router-dom";
import Login from "../Authentication/Login";
import ProtectedRoutes from "./ProtectedRoutes";
import routes from './routes'
import {homeFor, role} from "../Components/NavBar";

export default function MainRouter() {

    const LoginRequirement = () => {
        return (
            (localStorage.getItem("_MIHEALTHTOKEN") || localStorage.getItem("_MIHEALTHACCESSTOKEN"))
                ? <Navigate to={homeFor(role())}/> : <Login/>
        );
    };

    const renderProtectedRoutes = () => {
        return (
            <Route element={<ProtectedRoutes/>}>
                {routes.map((route) => {
                    return (
                        <Route
                            key={route.id}
                            path={route.path}
                            name={route.name}
                            element={route.element}
                        />)
                })}
            </Route>)
    }
    return (
        <Routes>
            {renderProtectedRoutes()}
            <Route path="/" element={<LoginRequirement/>}/>
        </Routes>
    )
}